export const ECOMM_URL = "https://serviceecom.devsaycheese.com";

let condition =
  window.location.hostname === "devsaycheese.com" ||
  window.location.hostname === "www.devsaycheese.com" ||
  window.location.hostname === "uat.devsaycheese.com";
const BASE_URL = condition
  ? "https://api.devsaycheese.com"
  : "https://api.devsaycheese.com";
const AUTH_API = "auth/api";
const SEEKER_API = "seeker/api";
const GIVER_API = "giver/api";
const GIVER_ECOMM_API = "giver/ecomm/api";

//website content
export const homepageContent = `${BASE_URL}/website/api/homepage`;
export const getAllBlogsUrl = `${BASE_URL}/website/api/allblogs`;
export const getBlogUrl = `${BASE_URL}/website/api/blog/`;
export const recentPostsUrl = `${BASE_URL}/website/api/recentblogs`;
export const featuredBlogUrl = `${BASE_URL}/website/api/featuredblog`;
export const getContactDropUrl = `${BASE_URL}/admin/api/getcontactusdropdown/`;
export const getHomeBanner = `${BASE_URL}/website/api/get_home_banner/`;
export const getEventsUrl = `${BASE_URL}/website/api/events`;
export const countriesUrl = `${BASE_URL}/website/api/countries/`;
export const statesUrl = `${BASE_URL}/website/api/states/`;
export const citiesUrl = `${BASE_URL}/website/api/cities/`;
export const categoriesUrl = `${BASE_URL}/giver/ecomm/api/categories`;

export const ifscUrl = "https://ifsc.razorpay.com/";

//onboarding
export const signUpUrl = `${BASE_URL}/${AUTH_API}/newsignup/`;
export const mobileVerificationUrl = `${BASE_URL}/${AUTH_API}/mobile-verification/`;
export const mobileOtpVerify = `${BASE_URL}/${AUTH_API}/verifyregmobileotp/`;
export const mobileOtpUrl = `${BASE_URL}/${AUTH_API}/regmobileotp/`;
export const emailVerificationUrl = `${BASE_URL}/${AUTH_API}/email-verification/`;
export const genderUrl = `${BASE_URL}/${AUTH_API}/accept_gender/`;
export const setPasswordUrl = `${BASE_URL}/${AUTH_API}/setpassword/`;
export const wwFormUrl = `${BASE_URL}/${SEEKER_API}/createuser/`;
export const giverFormUrl = `${BASE_URL}/${GIVER_API}/createuser/`;
export const isEmailVerified = `${BASE_URL}/${AUTH_API}/isemailverified/`;
export const submitQueryUrl = `${BASE_URL}/website/api/contactus/`;
export const updateCredUrl = `${BASE_URL}/${AUTH_API}/updatecredential/`;
export const giverOnboardingURL = `${BASE_URL}/${GIVER_ECOMM_API}/onboarding/`;
export const couponCheckURL = `${BASE_URL}/${GIVER_ECOMM_API}/onboarding/apply_coupon/`;
//user
export const userDataUrlB = `${BASE_URL}/both/api/mydata/`;
export const profileDataUrlB = `${BASE_URL}/both/api/myprofile`;
//auth
export const loginUrl = `${BASE_URL}/${AUTH_API}/newlogin/`;
export const forgotPasswordUrl = `${BASE_URL}/${AUTH_API}/forgotpassword/`;
export const verifyForgotPasswordUrl = `${BASE_URL}/${AUTH_API}/verify-forgot-password/`;
export const resetPasswordUrl = `${BASE_URL}/${AUTH_API}/updatepassword/`;
export const checkAvailabilityUrl = `${BASE_URL}/${AUTH_API}/checkavailability/`;
export const resendOtpUrl = `${BASE_URL}/${AUTH_API}/resend-otp/`;
export const updatePasswordUrl = `${BASE_URL}/${AUTH_API}/changepassword/`;

//data //seeker

export const getCoachingPackageDetail = (pkgId) =>
  `${BASE_URL}/${SEEKER_API}/viewcoachingpackage/${pkgId}`;
export const getWorkshopDetail = (id) =>
  `${BASE_URL}/${SEEKER_API}/viewworkshop/${id}`;

export const seekerHomepage = `${BASE_URL}/${SEEKER_API}/home`;
export const userDataUrl = `${BASE_URL}/${SEEKER_API}/mydata/`;
export const profileDataUrl = `${BASE_URL}/${SEEKER_API}/view_profile/`;
export const updateProfileUrl = `${BASE_URL}/${SEEKER_API}/update_profile/`;
export const questionnaireUrl = `${BASE_URL}/${SEEKER_API}/calculatehappinessindex/`;
export const reportDataUrl = `${BASE_URL}/${SEEKER_API}/myhappinessreport/`;
export const resourceDataUrl = `${BASE_URL}/${SEEKER_API}/viewallresources/`;
export const viewCoachingUrl = `${BASE_URL}/${SEEKER_API}/viewcoachingpackages/`;
export const viewWorkshopUrl = `${BASE_URL}/${SEEKER_API}/view_all_workshop/`;
export const interestedWorkshopUrl = `${BASE_URL}/${SEEKER_API}/interested_workshop/`;
export const viewFreelanceUrl = `${BASE_URL}/${SEEKER_API}/viewfreelancepackages/`;
export const viewTherapyUrl = `${BASE_URL}/${SEEKER_API}/viewtherapypackages/`;
export const viewDigitalUrl = `${BASE_URL}/${SEEKER_API}/viewdigitalservicespackages/`;
export const viewAllInspirationUrl = `${BASE_URL}/${SEEKER_API}/view_all_inspiration/`;
export const getCategoriesUrl = `${BASE_URL}/${SEEKER_API}/getcategories/`;
export const likeInspirationUrl = `${BASE_URL}/${SEEKER_API}/like_inspiration/`;
export const addInspirationUrl = `${BASE_URL}/${SEEKER_API}/addinspiration/`;
export const deleteInspirationUrl = `${BASE_URL}/${SEEKER_API}/deleteinspiration/`;
export const editInspirationUrl = `${BASE_URL}/${SEEKER_API}/editinspiration/`;
export const viewTransactionUrl = `${BASE_URL}/${SEEKER_API}/transaction/`;
export const getMyReportsUrl = `${BASE_URL}/${SEEKER_API}/servicereports/`;
export const cancelPackageUrl = `${BASE_URL}/${SEEKER_API}/cancelpackage/`;
export const servicesFeedbackUrl = `${BASE_URL}/${SEEKER_API}/servicesfeedback/`;
export const viewGiversFeedbackUrl = `${BASE_URL}/${SEEKER_API}/viewfeedback/`;
export const giversFeedbackActionUrl = `${BASE_URL}/${SEEKER_API}/viewfeedbackaction/`;
export const getAdsUrl = `${BASE_URL}/${SEEKER_API}/view_all_advertisement/`;
export const getIkigaiAnswersUrl = `${BASE_URL}/${SEEKER_API}/viewikigai/`;
export const submitIkigaiUrl = `${BASE_URL}/${SEEKER_API}/submit_ikigai/`;
export const getProgressUrl = `${BASE_URL}/${SEEKER_API}/progress/`;
export const getNotificationsUrl = `${BASE_URL}/${SEEKER_API}/seekernotifications/`;
export const interestedClubUrl = `${BASE_URL}/${SEEKER_API}/joinclubs/`;
export const UTMClick = `${BASE_URL}/${SEEKER_API}/utm_click/`;
export const getFreeCoaching = `${BASE_URL}/${SEEKER_API}/getfreecoaching/`;
export const getEmotionalEatingResponseDataUrl = `${BASE_URL}/${SEEKER_API}/emotionaleating_response/`;
export const getStressMgmtResponseDataUrl = `${BASE_URL}/${SEEKER_API}/stressmanagement_response/`;
export const getNetworkingResponseDataUrl = `${BASE_URL}/${SEEKER_API}/networking_response/`;
export const getBodyShamingResponseDataUrl = `${BASE_URL}/${SEEKER_API}/bodyshaming_response/`;
export const getNurturingResponseDataUrl = `${BASE_URL}/${SEEKER_API}/nurturing_response/`;
export const getHeartbreakResponseDataUrl = `${BASE_URL}/${SEEKER_API}/heartbreaking_response/`;
export const getBurnoutResponseDataUrl = `${BASE_URL}/${SEEKER_API}/burnout_response/`;
export const getFaliureResponseDataUrl = `${BASE_URL}/${SEEKER_API}/failure_response/`;
export const getLeadershipResponseDataUrl = `${BASE_URL}/${SEEKER_API}/leadership_response/`;
export const getIkigaiResponseDataUrl = `${BASE_URL}/${SEEKER_API}/ikigai_response/`;

//data //giver
export const giverHomepage = `${BASE_URL}/${GIVER_API}/home`;
export const userDataUrlG = `${BASE_URL}/${GIVER_API}/mydata/`;
export const profileDataUrlG = `${BASE_URL}/${GIVER_API}/view_profile/`;
export const updateProfileUrlG = `${BASE_URL}/${GIVER_API}/update_profile/`;
export const viewMyInspirationUrl = `${BASE_URL}/${GIVER_API}/myinspirations/`;
export const addInspirationUrlG = `${BASE_URL}/${GIVER_API}/addinspiration/`;
export const deleteInspirationUrlG = `${BASE_URL}/${GIVER_API}/deleteinspiration/`;
export const editInspirationUrlG = `${BASE_URL}/${GIVER_API}/editinspiration/`;
export const viewTransactionUrlG = `${BASE_URL}/${GIVER_API}/transaction/`;
export const addWorkshopUrl = `${BASE_URL}/${GIVER_API}/submit_workshop/`;
export const getCoachingPackagesUrl = `${BASE_URL}/${GIVER_API}/coachingpackages/`;
export const getTherapyPackagesUrl = `${BASE_URL}/${GIVER_API}/therapypackages/`;
export const getDigitalServicePackagesUrl = `${BASE_URL}/${GIVER_API}/digitalservicepackages/`;
export const getFreelancePackagesUrl = `${BASE_URL}/${GIVER_API}/freelancepackages/`;
export const initiateEndSessionUrl = `${BASE_URL}/${GIVER_API}/verifysession/`;
export const endSessionUrl = `${BASE_URL}/${GIVER_API}/generatereport/`;
export const getProgressUrlG = `${BASE_URL}/${GIVER_API}/progress/`;
export const getNotificationsUrlG = `${BASE_URL}/${GIVER_API}/givernotifications/`;

//payment
//seeker
//hashes
export const getHashCoachingUrl = `${BASE_URL}/${SEEKER_API}/subscribe_coaching/`;
export const getHashDigitalUrl = `${BASE_URL}/${SEEKER_API}/subscribe_digitalservices/`;
export const getHashFreelanceUrl = `${BASE_URL}/${SEEKER_API}/subscribe_freelance/`;
export const getHashTherapyUrl = `${BASE_URL}/${SEEKER_API}/subscribe_therapy/`;
export const getHashWorkshopUrl = `${BASE_URL}/${SEEKER_API}/subscribe_workshop/`;
export const getHashModuleUrl = `${BASE_URL}/${SEEKER_API}/subscribe_module/`;
export const getHashGiverUrl = `${BASE_URL}/${GIVER_ECOMM_API}/onboarding/subscription_payment/`;

//success
export const successCoachingUrl = `${BASE_URL}/${SEEKER_API}/success_coaching/`;
export const successDigitalUrl = `${BASE_URL}/${SEEKER_API}/success_digitalservices/`;
export const successFreelanceUrl = `${BASE_URL}/${SEEKER_API}/success_freelance/`;
export const successTherapyUrl = `${BASE_URL}/${SEEKER_API}/success_therapy/`;
export const successWorkshopUrl = `${BASE_URL}/${SEEKER_API}/success_workshop/`;
export const successModuleUrl = `${BASE_URL}/${SEEKER_API}/success_module/`;
export const successGiverUrl = `${BASE_URL}/${GIVER_ECOMM_API}/onboarding/subscription_success/`;

//failure
export const failureCoachingUrl = `${BASE_URL}/${SEEKER_API}/failure_coaching/`;
export const failureDigitalUrl = `${BASE_URL}/${SEEKER_API}/failure_digitalservices/`;
export const failureFreelanceUrl = `${BASE_URL}/${SEEKER_API}/failure_freelance/`;
export const failureTherapyUrl = `${BASE_URL}/${SEEKER_API}/failure_therapy/`;
export const failureWorkshopUrl = `${BASE_URL}/${SEEKER_API}/failure_workshop/`;
export const failureModuleUrl = `${BASE_URL}/${SEEKER_API}/failure_module/`;
export const failureGiverPaymentUrl = `${BASE_URL}/${GIVER_ECOMM_API}/onboarding/subscription_failure/`;
//giver
//hashes
export const getHashCoachingUrlG = `${BASE_URL}/${GIVER_API}/subscribe_coaching/`;
export const getHashDigitalUrlG = `${BASE_URL}/${GIVER_API}/subscribe_digitalservices/`;
export const getHashFreelanceUrlG = `${BASE_URL}/${GIVER_API}/subscribe_freelance/`;
export const getHashTherapyUrlG = `${BASE_URL}/${GIVER_API}/subscribe_therapy/`;
//success
export const successCoachingUrlG = `${BASE_URL}/${GIVER_API}/success_coaching/`;
export const successDigitalUrlG = `${BASE_URL}/${GIVER_API}/success_digitalservices/`;
export const successFreelanceUrlG = `${BASE_URL}/${GIVER_API}/success_freelance/`;
export const successTherapyUrlG = `${BASE_URL}/${GIVER_API}/success_therapy/`;
//failure
export const failureCoachingUrlG = `${BASE_URL}/${GIVER_API}/failure_coaching/`;
export const failureDigitalUrlG = `${BASE_URL}/${GIVER_API}/failure_digitalservices/`;
export const failureFreelanceUrlG = `${BASE_URL}/${GIVER_API}/failure_freelance/`;
export const failureTherapyUrlG = `${BASE_URL}/${GIVER_API}/failure_therapy/`;
export const googleAuthUrl = `${BASE_URL}/${AUTH_API}/googlesignupaction/`;
export const facebookAuthUrl = `${BASE_URL}/${AUTH_API}/fbsignupaction/`;
export const getOnBoardingData = `${BASE_URL}/${AUTH_API}/getonboardingdata/`;
